<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12 text-center">
        <registration-progress-bar
          title-reg="Where are you buying from?"
          progress="40"
        ></registration-progress-bar>
        <br />
        <div class="row">
          <div class="col-sm-6">
            <h4>Canada</h4>
            <button
              id="step2CA"
              type="button"
              class="btn btn-primary btn-block"
              @click.prevent="nextStep('en-CA')"
            >
              Buying for Canada
            </button>
          </div>

          <div class="col-sm-6">
            <h4>United States</h4>
            <button
              id="step2US"
              type="button"
              class="btn btn-primary btn-block"
              @click.prevent="nextStep('en-US')"
            >
              Buying for United States
            </button>
          </div>
        </div>
        <br />
        <next-prev-buttons></next-prev-buttons>
      </div>
    </div>
    <scroll></scroll>
  </div>
</template>

<script>
export default {
  methods: {
    nextStep(locale) {
      this.$store.dispatch("setLocaleId", locale);
      this.$store.dispatch("setLocale", locale);
      this.$store.dispatch("nextStep");
    },
  },
};
</script>
